import { TailwindColor } from '@repo/tailwind-config/tailwind.vars'

type Props = {
  color1: TailwindColor
  color2: TailwindColor
  color3: TailwindColor
}

const LoginGroupTwoIcon: React.FC<Props> = ({ color1, color2, color3 }) => {
  return (
    <svg
      width="254"
      height="255"
      viewBox="0 0 254 255"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="127.064" y="127.062" width="127.063" height="127.066" fill={color1} />
      <path
        d="M127.066 254.131C110.38 254.131 93.8569 250.845 78.4409 244.459C63.0249 238.073 49.0175 228.714 37.2186 216.915C25.4198 205.115 16.0604 191.108 9.67484 175.691C3.28932 160.275 0.00273957 143.752 0.00274103 127.066C0.00274249 110.379 3.28933 93.856 9.67485 78.4397C16.0604 63.0234 25.4198 49.0158 37.2187 37.2166C49.0176 25.4175 63.0249 16.0579 78.4409 9.67228C93.8569 3.28664 110.38 -7.74238e-06 127.066 -5.55421e-06L127.066 127.066L127.066 254.131Z"
        fill={color3}
      />
      <path
        d="M127.066 254.131C110.38 254.131 93.8569 250.845 78.4409 244.459C63.0249 238.073 49.0176 228.714 37.2186 216.915C25.4197 205.115 16.0604 191.108 9.67484 175.691C3.28931 160.275 0.0027403 143.752 0.00274103 127.066L127.066 127.066L127.066 254.131Z"
        fill="white"
      />
      <path
        d="M127.064 181.204C119.664 181.204 112.337 179.803 105.5 177.083C98.6636 174.362 92.4517 170.374 87.2191 165.346C81.9865 160.319 77.8359 154.35 75.004 147.782C72.1722 141.213 70.7147 134.173 70.7147 127.063L127.064 127.063L127.064 181.204Z"
        fill={color2}
      />
      <ellipse cx="190.596" cy="63.5328" rx="63.5315" ry="63.5328" fill="white" />
      <ellipse cx="191.143" cy="62.9846" rx="30.9371" ry="30.9377" fill={color1} />
      <rect x="160.206" y="154.688" width="61.8742" height="61.8754" fill={color3} />
    </svg>
  )
}

export default LoginGroupTwoIcon
